import React, { useState, useContext, useMemo, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { UserContext } from "../UserContext";
import ConnString from "../../../../ConnString.js";
import { Stack,useTheme  } from "@mui/material";
import { tokens, ColorModeContext } from "../../../../theme.js";
 
const Connstring2 = ConnString.connstring;

const Retainerist = ({ companies, dateFrom, dateTo, refreshCompanies }) => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const mode = theme.palette.mode; // "light" | "dark"
    
    const t = (group, shade, fallback) => {
    return colors?.[group]?.[shade] ?? fallback;
    };

    useContext(ColorModeContext);

    const [isSaving, setIsSaving] = useState(false);
    const [userEmail, setUserEmail] = useState(sessionStorage.getItem("userEmail"));
    
  const [searchTerm, setSearchTerm] = useState('');
  const [filter, setFilter] = useState('all'); // kept
  const [selectedCompany, setSelectedCompany] = useState(null); // will store ContractID now
  const [selectedCell, setSelectedCell] = useState(null); // extra info for modal + highlight
  const [newStatus, setNewStatus] = useState('');
  const [remarks, setRemarks] = useState('');
  const [showModal, setShowModal] = useState(false);
 
 
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [hoveredCellId, setHoveredCellId] = useState(null);
    const matrixRef = useRef(null);


  const compID = sessionStorage.getItem("compID");
  const userID = sessionStorage.getItem("userID");
  const { username } = useContext(UserContext);

  const navigate = useNavigate();

  const handleStatusChange = (e) => setNewStatus(e.target.value);
  const handleRemarksChange = (e) => setRemarks(e.target.value);

  // ✅ cell click opens modal using ContractID
  const markUpdate = (cell) => {
    if (!cell?.ContractID) return;

    setSelectedCompany(cell.ContractID); // keep existing variable name, but it's ContractID now
    setSelectedCell(cell);

    // optional: prefill dropdown with current status
    setNewStatus(cell.Statusx || '');
    setRemarks('');
    setShowModal(true);
  };

  const enterFullscreen = () => {
  if (!matrixRef.current) return;
  const el = matrixRef.current;

  if (el.requestFullscreen) el.requestFullscreen();
  else if (el.webkitRequestFullscreen) el.webkitRequestFullscreen(); // Safari
};

    const exitFullscreen = () => {
    if (document.exitFullscreen) document.exitFullscreen();
    else if (document.webkitExitFullscreen) document.webkitExitFullscreen(); // Safari
    };

    useEffect(() => {
    const onChange = () => {
        const fsEl = document.fullscreenElement || document.webkitFullscreenElement;
        setIsFullscreen(Boolean(fsEl));
    };

    document.addEventListener("fullscreenchange", onChange);
    document.addEventListener("webkitfullscreenchange", onChange);

    return () => {
        document.removeEventListener("fullscreenchange", onChange);
        document.removeEventListener("webkitfullscreenchange", onChange);
    };
    }, []);

  const handleUpdate = async (e) => {

    e?.preventDefault?.(); // ✅ if called from a form submit
    e?.stopPropagation?.(); // ✅ prevents bubbling to parent click handlers
   
    if (isSaving) return;   // ✅ prevents multi-click / double-fire
    setIsSaving(true);


    try {
      if (!selectedCompany) {
        alert('Please select a record.');
        return;
      }

      const snewstatus = newStatus;
      const sremarks = remarks;
      //const suser = username || "System";
      //const suser = sessionStorage.username ||username;

      const suser =  userEmail;

      if (!snewstatus || !sremarks || !suser) {
        alert('Missing status, remarks, or user. Please fill in all fields.');
        return;
      }

      // ✅ selectedCompany = ContractID
      const response = await fetch(`${Connstring2}/api/updateretainer/${selectedCompany}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          companyID: compID,
          newStatus: snewstatus,
          remarks: sremarks,
          user: suser
        }),
      });

      if (!response.ok) {
        throw new Error(`Failed to update the record: ${response.statusText}`);
      }

      alert('Updated successfully!');
      setShowModal(false);
      refreshCompanies();
    } catch (error) {
      console.error('Error updating task:', error);
      alert('Failed to update. Please try again.');
    
    } finally {
    setIsSaving(false);
   }
  };

  const searchItems = (e) => setSearchTerm(e.target.value);

   
  // ---------- helpers ----------
  const toMonthKey = (d) => {
    if (!d) return null;
    const dt = new Date(d);
    if (Number.isNaN(dt.getTime())) return null;
    const y = dt.getFullYear();
    const m = String(dt.getMonth() + 1).padStart(2, "0");
    return `${y}-${m}`;
  };

  const toMonthLabel = (monthKey) => {
    const [y, m] = monthKey.split("-");
    const dt = new Date(Number(y), Number(m) - 1, 1);
    return dt.toLocaleString("en-US", { month: "short" }); // Jan, Feb...
  };

  const peso = (n) =>
    (n ?? 0).toLocaleString("en-PH", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  const statusPriority = (s) => {
    if (s === "Collected") return 3;
    if (s === "Billed") return 2;
    if (s === "For Billing") return 1;
    return 0;
  };

//   const statusColor = (s) => {
//     if (s === "Collected") return "#d9f5dc";   // green
//     if (s === "Billed") return "#d9f0fb";      // blue
//     if (s === "For Billing") return "#fde7d9"; // orange
//     return "#ffffff";
//   };

    const STATUS_THEME_COLORS = {
        Collected: {
            light: t("greenAccent", 500, theme.palette.success.light),
            dark: t("greenAccent", 700, theme.palette.success.dark),
        },
        Billed: {
            light: t("blueAccent", 500, theme.palette.info.light),
            dark: t("blueAccent", 700, theme.palette.info.dark),
        },
        "For Billing": {
            // orangeAccent may not exist in your tokens -> fallback to warning palette
            light: t("orangeAccent", 500, theme.palette.warning.light),
            dark: t("orangeAccent", 700, theme.palette.warning.dark),
        },
            };

    const statusColor = (status) =>
     STATUS_THEME_COLORS[status]?.[mode] ?? theme.palette.background.default;

        const statusTextColor = () =>
        mode === "dark" ? theme.palette.grey[100] : theme.palette.grey[900];

   const statusHoverColor = (status) => {
  switch (status) {
    case "Collected":
      return mode === "dark"
        ? t("greenAccent", 700, theme.palette.success.main)
        : t("greenAccent", 400, theme.palette.success.light);

    case "Billed":
      return mode === "dark"
        ? t("blueAccent", 700, theme.palette.info.main)
        : t("blueAccent", 400, theme.palette.info.light);

    case "For Billing":
      return mode === "dark"
        ? t("orangeAccent", 700, theme.palette.warning.main)
        : t("orangeAccent", 400, theme.palette.warning.light);

    default:
      return undefined;
  }
};

  // ---------- filter ----------
  const filteredCompanies = useMemo(() => {
    const term = searchTerm.trim().toLowerCase();

    const df = dateFrom ? new Date(dateFrom) : null;
    const dt = dateTo ? new Date(dateTo) : null;

    return (companies || [])
      .filter(r => {
        const name = (r.CompanyName || '').toLowerCase();
        return !term || name.includes(term);
      })
      .filter(r => {
        if (!r.BillingDate) return true;
        const bd = new Date(r.BillingDate);
        if (Number.isNaN(bd.getTime())) return true;
        if (df && bd < df) return false;
        if (dt && bd > dt) return false;
        return true;
      });
  }, [companies, searchTerm, dateFrom, dateTo]);

  // ---------- months ----------
  const months = useMemo(() => {
    const set = new Set();
    for (const r of filteredCompanies) {
      const mk = toMonthKey(r.BillingDate);
      if (mk) set.add(mk);
    }
    return Array.from(set).sort();
  }, [filteredCompanies]);

  // ---------- clients ----------
  const clients = useMemo(() => {
    const set = new Set();
    for (const r of filteredCompanies) {
      if (r.CompanyName) set.add(r.CompanyName);
    }
    return Array.from(set).sort((a, b) => a.localeCompare(b));
  }, [filteredCompanies]);

  // ---------- cell map ----------
  // key = CompanyName__Month -> { Amount, Statusx, ContractID, CompanyName, MonthKey }
  const cellMap = useMemo(() => {
    const map = new Map();

    for (const r of filteredCompanies) {
      const name = r.CompanyName || "";
      const monthKey = toMonthKey(r.BillingDate);
      if (!name || !monthKey) continue;

      const key = `${name}__${monthKey}`;
      const prev = map.get(key);

      const amt = Number(r.Amount ?? 0);
      const rank = statusPriority(r.Statusx);

      if (!prev) {
        map.set(key, {
          CompanyName: name,
          MonthKey: monthKey,
          Amount: amt,
          Statusx: r.Statusx || "",
          ContractID: r.ContractID,       // ✅ unique record for update
          statusRank: rank,
          Remarks: r.Remarks,
        });
      } else {
        // sum amount; keep best status + its ContractID
        const nextAmount = (prev.Amount ?? 0) + amt;

        if (rank >= prev.statusRank) {
          map.set(key, {
            CompanyName: name,
            MonthKey: monthKey,
            Amount: nextAmount,
            Statusx: r.Statusx || prev.Statusx,
            ContractID: r.ContractID ?? prev.ContractID,
            statusRank: rank,
            Remarks: r.Remarks,

          });
        } else {
          map.set(key, { ...prev, Amount: nextAmount });
        }
      }
    }

    return map;
  }, [filteredCompanies]);


  return (
    <div style={styles.CenterSection} backgroundColor={colors.primary[400]}>
      <div style={styles.contentWrapper}>

        <div   style={styles.inventorycontrols} backgroundColor={colors.primary[400]}> 
          <Stack justifyContent="space-between" alignItems="center" spacing={1} backgroundColor={colors.primary[400]}  sx={{ flexGrow: 1 }}>
            
            {/* <h3>Retainer Monitoring</h3> */}
            <input
              type="text"
              id="searchInput"
              placeholder="Search Company..."
              value={searchTerm}
              onChange={searchItems}
              style={{ width: '100%', maxWidth: '500px', height: "30px" }}
            />
          </Stack>

         <div style={{ marginLeft: "auto", display: "flex", gap: 8 }}>
                <button
                    type="button"
                    className="btn btn-outline-secondary btn-sm"
                    onClick={() => (isFullscreen ? exitFullscreen() : enterFullscreen())}
                >
                    {isFullscreen ?  "": "⛶"}
                </button>
                </div>

    
        </div>

        {/* MATRIX TABLE */}
        <div  ref={matrixRef} 
         style={{
            ...styles.tableContainer,
            ...(isFullscreen ? styles.fullscreenContainer : {}),
            backgroundColor: colors.primary[400],
          }}
        >
          <table id="retainerMatrixTable" style={styles.table} backgroundColor={colors.primary[400]}>
            <thead>
              <tr>
                <th style={{ ...styles.th, ...styles.stickyLeft, minWidth: 320, backgroundColor: colors.primary[400]  }}>Name</th>
                {months.map(mk => (
                  <th key={mk} style={{ ...styles.th, textAlign: "center", minWidth: 100,backgroundColor: colors.primary[400] }} >
                    {toMonthLabel(mk)}
                  </th>
                ))}
              </tr>
            </thead>

            <tbody>
              {clients.map((clientName) => (
                <tr key={clientName}>
                  <td style={{ ...styles.td, ...styles.stickyLeft, fontWeight: 600,backgroundColor: colors.primary[400] }}>
                    {clientName}
                  </td>

                  {months.map((mk) => {
                    const cell = cellMap.get(`${clientName}__${mk}`);
                    if (!cell) return <td key={mk} style={{ ...styles.td, textAlign: "right" }}  />;

                    const isSelected = selectedCell?.ContractID === cell.ContractID;

                    return (
                      <td
                        // key={mk}
                        // style={{
                        //   ...styles.td,
                        //   textAlign: "right",
                        //   backgroundColor: statusColor(cell.Statusx),
                        //   color: statusTextColor(cell.Statusx),
                        //   cursor: cell.ContractID ? "pointer" : "default",
                        //   fontWeight: 600,
                        //   outline: isSelected ? "2px solid #0d6efd" : "none",
                        //   outlineOffset: isSelected ? "-2px" : "0",
                        
                        // }}
                        // title={`Status: ${cell.Statusx}\nContractID: ${cell.ContractID}`}
                        // onClick={() => markUpdate(cell)}
                          key={mk}
                            onMouseEnter={() => setHoveredCellId(cell.ContractID)}
                            onMouseLeave={() => setHoveredCellId(null)}
                            style={{
                                ...styles.td,
                                textAlign: "right",
                                backgroundColor:
                                    hoveredCellId === cell.ContractID
                                        ? statusHoverColor(cell.Statusx)
                                        : statusColor(cell.Statusx),
                                color: statusTextColor(cell.Statusx),
                                cursor: cell.ContractID ? "pointer" : "default",
                                fontWeight: 600,
                                outline: isSelected ? "2px solid #0d6efd" : "none",
                                outlineOffset: isSelected ? "-2px" : "0",
                                transition: "background-color 120ms ease-in-out",
                            }}
                            title={`Status: ${cell.Statusx}\nContractID: ${cell.ContractID}\nRemarks: ${cell.Remarks}`}
                            onClick={() => markUpdate(cell)}
                    
                      >
                        {peso(cell.Amount)}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Modal for Updating Status */}
        {showModal && (
            <>
             {/* Backdrop */}
                <div
                className="modal-backdrop show"
                   style={{
                    zIndex: 10050,
                    position: "fixed",
                    inset: 0,
                }}
                onClick={() => setShowModal(false)}
                />
            <div className="modal show fade" tabIndex="-1"  
                  style={{
                        display: "flex",
                        position: "fixed",
                        inset: 0,
                        zIndex: 10060,
                        alignItems: "center",
                        justifyContent: "center",
                        overflow: "auto",
                    }}
            >
            <div className="modal-dialog" onClick={(e) => e.stopPropagation()}>  
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Update Status</h5>
                  <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
                </div>

                <div className="modal-body">
                  <p style={{ marginBottom: 10 }}>
                    <b>{selectedCell?.CompanyName}</b> — <b>{toMonthLabel(selectedCell?.MonthKey || "")}</b><br />
                    Amount: <b>{peso(selectedCell?.Amount)}</b><br />
                    ContractID: <b>{selectedCell?.ContractID}</b><br />
                    Current Status: <b>{selectedCell?.Statusx}</b>
                  </p>

                  <select className="form-select" value={newStatus} onChange={handleStatusChange}>
                    <option value="">Select Status</option>
                    <option value="For Billing">For Billing</option>
                    <option value="Billed">Billed</option>
                    <option value="Collected">Collected</option>
                  </select>

                  {newStatus && (
                    <div className="mt-3">
                      <label>Remarks:</label>
                      <textarea
                        className="form-control"
                        rows="3"
                        value={remarks}
                        onChange={handleRemarksChange}
                        placeholder="Enter additional remarks here..."
                      />
                    </div>
                  )}
                </div>

                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>Cancel</button>
                  {/* <button type="button" className="btn btn-primary" onClick={handleUpdate} disabled={!newStatus}> 
                    Update
                  </button>
                  */}
                  <button type="button" className="btn btn-primary" onClick={handleUpdate} disabled={!newStatus || isSaving}> {isSaving ? "Updating..." : "Update"}</button>
                  
                </div>
              </div>
            </div>
          </div>
          </>
        )}

        {/* Legend */}
        <div style={{ marginTop: 10, display: "flex", gap: 12, justifyContent: "center", alignItems: "center" }}>
          <LegendItem color="#fde7d9" label="For Billing" />
          <LegendItem color="#d9f0fb" label="Billed" />
          <LegendItem color="#d9f5dc" label="Collected" />
        </div>
      </div>
    </div>
  );
};

const LegendItem = ({ color, label }) => (
  <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
    <div style={{ width: 18, height: 18, backgroundColor: color, border: "1px solid #ccc" }} />
    <span style={{ fontSize: 13 }}>{label}</span>
  </div>
);

const styles = {
  CenterSection: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'top',
    height: '100vh',
   // backgroundColor: '#f2f2f2',
  },
  contentWrapper: {
    width: '100%',
    maxWidth: '2000px',
    padding: '20px',
 //   backgroundColor: '#ffffff',
    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
    borderRadius: '8px',
    textAlign: 'center',
  },
  inventorycontrols: {
    marginBottom: '20px',
    display: 'flex',
    justifyContent: 'Left',
    gap: '10px',
  },
  tableContainer: {
    maxHeight: '800px',
    overflow: 'auto',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
  },
  th: {
    position: 'sticky',
    top: 0,
   // backgroundColor: '#cfe9f5',
    zIndex: 2,
    border: '1px solid #000',
    padding: '8px',
    textAlign: 'left',
    whiteSpace: 'nowrap',
  },
  td: {
    border: '1px solid #000',
    padding: '8px',
    textAlign: 'left',
    whiteSpace: 'nowrap',
  },
  stickyLeft: {
    position: "sticky",
    left: 0,
    zIndex: 3,
  },
 

};

export default Retainerist;
